export const modalEmailJaExistente = {
  id: 'email-existente',
  titulo: 'E-mail já cadastrado',
  texto:
    'Este e-mail já possui uma conta ativa. Se você deseja solicitar novos produtos clique em acessar minha conta. Se não, informe outro e-mail.',
  btnAcessarConta: 'Acessar minha conta',
  btnCancelar: 'Informar novo E-mail',
};

export const modalCPFJaExistente = {
  id: 'cpf-existente',
  titulo: 'CPF já cadastrado',
  texto:
    'Este CPF já possui uma conta ativa. Se você deseja solicitar novos produtos clique em acessar minha conta. Se não, digite outro CPF.',
  btnAcessarConta: 'Acessar minha conta',
  btnCancelar: 'Informar novo CPF',
};

export const modalAguarde = {
  id: 'modal-aguarde',
  titulo: 'Aguarde',
  texto:
    'A validação dos dados tá levando mais tempo que o normal. Por favor, aguarde um pouquinho.',
};

export const modalNaoAprovado = {
  id: 'modal-nao-aprovado',
  texto1: 'Ops! Infelizmente, não foi possível aprovar seu pedido no momento.',
  texto2:
    'Você pode enviar uma nova proposta utilizando outro CPF ou tentar novamente mais tarde!',
};

export const modalErroCartao = {
  id: 'modal-cartao-nao-aprovado',
  texto:
    'O cartão digitado não é válido para aderir à essa promoção. Por favor, digite um cartão válido.',
};
export const modalErroDebito = {
  id: 'modal-debito-nao-aprovado',
  texto:
    'A agência e conta inseridos não são válidos. Por favor, reveja os dados inseridos.',
};

export const modalErroPagamento = {
  id: 'modal-erro-pagamento',
  texto:
    'Não foi possível validar os dados de pagamento. Por favor, tente novamente mais tarde.',
};

export const modalFinalizandoPagamento = {
  id: 'modal-finalizando-pagamento',
  titulo: 'Aguarde',
  texto: 'Aguarde um pouquinho, estamos finalizando seu pedido.',
};

export const retornoBraspag = {
  cod77:
    'O cartão não é válido. Por favor, reveja os dados inseridos ou entre em contato com seu banco.',
  cod70:
    'O cartão digitado não é válido para aderir à essa promoção. Por favor, digite um cartão válido.',
  cod78:
    'Seu cartão foi bloqueado. Por favor, entre em contato com o banco emissor do seu cartão.',
  cod57:
    'O cartão não é válido. Por favor, reveja os dados inseridos ou entre em contato com seu banco.',
};

export const modalTermos = {
  id: 'modal-termos',
  conteudo: `Termos e condições gerais de uso do sistema Veloe

  Planos de pagamento pré-pagos e pós-pagos

  Pelo presente instrumento denominado Termos e Condições Gerais de Uso do Sistema Veloe (“TDU”), a COMPANHIA BRASILEIRA DE SOLUÇÕES E SERVIÇOS, com sede na Alameda Xingu, n. 512, 3º e 4º andares, Edifício “Condomínio Evolution Corporate”, Alphaville, CEP 06455-030, no Município de Barueri, Estado de São Paulo, inscrita no CNPJ/MF sob o nº 04.740.876/0001-25 (doravante denominada “ALELO”), estabelece os termos e as condições para uso do SISTEMA VELOE pelo CLIENTE, de acordo com o PLANO DE PAGAMENTO contratado.


  1 - Definições


  1.1. As definições aplicadas em caixa alta, constantes no presente TDU, seus Anexos e Aditivos, no singular ou plural, terão o significado que lhes são atribuídos abaixo:


  (i) ADESÃO: significa a adesão do CLIENTE a este TDU e ao SISTEMA VELOE, nas formas especificadas na cláusula 3.1.

  (ii) APLICATIVO: aplicativo móvel da ALELO pelo qual o CLIENTE poderá contratar o SISTEMA VELOE, bem como o CLIENTE e os PORTADORES, quando aplicável, poderão utilizar o SISTEMA VELOE, consultar o SALDO DA CONTA DE PAGAMENTO, EXTRATOS, realizar TRANSAÇÕES nos ESTABELECIMENTOS, dentre outros.

  (iii) CANAIS DE ATENDIMENTO: composto pela CENTRAL DE ATENDIMENTO AO CLIENTE, pelo APLICATIVO e pelo SITE.

  (iv) CARGA: atribuição pelo CLIENTE, à CONTA DE PAGAMENTO PRÉ-PAGA associada a um ou mais IDENTIFICADORES e ao APLICATIVO instalado, de um crédito em moeda corrente nacional, conforme valor escolhido pelo CLIENTE na ocasião da ADESÃO.

  (v) CENTRAL DE ATENDIMENTO AO CLIENTE: central de relacionamento disponibilizada ao CLIENTE, que pode ser acessada por contato telefônico no número 3003-3510, para capitais e regiões metropolitanas, e no número 0800 208 3510, para demais localidades, disponível das 8 horas às 20 horas, de segunda feira a sábado; e/ou contato telefônico ao Serviço de Atendimento ao Consumidor (SAC), no número 0800 208 2010, e para deficientes auditivos e de fala no número 0800 208 2020, disponível 24 horas por dia, 7 dias por semana.

  (vi) CLIENTE: pessoa física ou jurídica que aderiu a este TDU, adquiriu IDENTIFICADORES e/ou instalou o APLICATIVO para uso nos termos deste TDU.

  (vii) CONCESSIONÁRIAS: empresas autorizadas a utilizar o SISTEMA VELOE para identificar, de forma automática, os VEÍCULOS que transitarem nas PRAÇAS DE PEDÁGIO em que operam, e que se propõem a receber o pagamento de tarifas de pedágio pelos PORTADORES USUÁRIOS por meio de TRANSAÇÕES realizadas com seus respectivos IDENTIFICADORES.

  (viii) CONTA DE PAGAMENTO: a CONTA DE PAGAMENTO PÓS-PAGA e a CONTA DE PAGAMENTO PRÉ-PAGA, quando referidas conjuntamente.

  (ix) CONTA DE PAGAMENTO PÓS-PAGA: conta individual de titularidade do CLIENTE, associada aos IDENTIFICADORES solicitados pelo CLIENTE e ao APLICATIVO instalado, que contratou o PLANO DE PAGAMENTO PÓS-PAGO, destinada à execução e registro de TRANSAÇÕES em moeda corrente nacional, que independem de aporte prévio.

  (x) CONTA DE PAGAMENTO PRÉ-PAGA: conta individual de titularidade do CLIENTE, associada aos IDENTIFICADORES solicitados pelo CLIENTE e ao APLICATIVO instalado que contratou o PLANO DE PAGAMENTO PRÉ-PAGO, destinada ao registro de valores em moeda corrente nacional previamente aportados pelo CLIENTE por meio de CARGA, RECARGA e/ou RECARGA AUTOMÁTICA, bem como ao registro de TRANSAÇÕES.

  (xi) ESTABELECIMENTOS: estacionamentos, postos de gasolina, drive-thru, lava rápido e demais estabelecimentos credenciados ao SISTEMA VELOE, que se propõem a receber pagamentos dos USUÁRIOS por meio de TRANSAÇÕES realizadas com seus respectivos IDENTIFICADORES ou pelo APLICATIVO.

  (xii) EXTRATO: discriminação das TRANSAÇÕES realizadas pelo USUÁRIO junto ao SISTEMA VELOE por meio do IDENTIFICADOR ou do APLICATIVO, bem como disponibilizada para consulta pelo CLIENTE de qualquer PLANO DE PAGAMENTO no SITE e, se disponibilizada a funcionalidade pela ALELO, na CENTRAL DE
  ATENDIMENTO AO CLIENTE e no APLICATIVO. O CLIENTE de qualquer PLANO DE PAGAMENTO poderá optar por receber mensalmente o EXTRATO impresso,
  conforme condições previamente acordadas entre as Partes.

  (xiii) FATURA: discriminação das TRANSAÇÕES realizadas junto ao SISTEMA VELOE por meio do IDENTIFICADOR ou por meio do APLICATIVO pelo USUÁRIO, que será disponibilizada no SITE e no APLICATIVO ao CLIENTE do PLANO DE PAGAMENTO PÓS-PAGO. O CLIENTE poderá optar por receber mensalmente a FATURA impressa, conforme condições previamente acordadas entre as Partes.

  (xiv) IDENTIFICADOR: instrumento eletrônico de pagamento e de identificação de VEÍCULO, tais como tiv, tag, smart tag, adesivo, gerenciado e habilitado pela ALELO nas modalidades pré-pago recarregável ou pós-pago, de acordo com o PLANO DE PAGAMENTO.


  2 - Objeto

  2.1. O presente TDU tem por objeto a prestação de serviços de identificação eletrônica e processamento de TRANSAÇÕES, que permite aos USUÁRIOS, mediante ADESÃO a este TDU pelo CLIENTE, a aquisição de bens e/ou serviços na REDE CREDENCIADA, conforme PLANO DE PAGAMENTO contratado pelo CLIENTE com a ALELO.

  2.2 A ALELO poderá oferecer SERVIÇOS ADICIONAIS ao CLIENTE, a título gratuito ou oneroso, de acordo com cada PLANO DE PAGAMENTO contratado. A disponibilização dos SERVIÇOS ADICIONAIS oferceidos de forma onerosa dependerá de prévia aceitação do CLIENTE A disponibilização dos SERVIÇOS ADICIONAIS ofereceidos de forma gratuita é, desde já, autorizada pelo CLIENTE, o qual poderá solicitar, a qualquer momento, o cancelamento de sua disponibilização, por meio dos CANAIS DE ATENDIMENTO, ou, ainda, quando disponível ao CLIENTE, pessoalmente, nos PONTOS DE VENDA.`,
};

export const listReceberAdesivo = [
  {
    id: 'sim',
    titulo: 'Sim',
    texto: 'Desejo receber em minha casa.',
    checkbox: false,
  },
  {
    id: 'nao',
    titulo: 'Não',
    texto: 'Já tenho e preciso apenas contratar um plano.',
    checkbox: false,
  },
];

export const instituicoes = [
  '001 - Branco do Brasil S.A.',
  '237 - Bradesco S.A.',
  '212 - Banco Original S.A.',
  '341 - Itaú Unibanco S.A.',
];

export const diaPagto = [5, 10, 15, 20, 25];

export const modalTarifas = (bonificacao, valor) => {
  const result = {
    inicioPagto: `Tarifa mensal por dispositivo ativo será cobrada a partir do ${bonificacao}º mês.`,
    aPartir: `A partir de R$${valor}0*`,
    tarifaAdesao: 'Grátis',
    tarifaEntrega: 'Grátis',
    inativacao: 'Grátis',
    extrato: 'Grátis',
    substituicao: 'Grátis',
    adicional: 'Grátis',
    devolucaoSaldo: 'R$ 7,50',
    recargaMinima: 'R$ 50',
  };

  return result;
};

export const modalRecarga = {
  titulo: 'Como funciona a recarga automática',
  cards: [
    {
      id: 1,
      icone: 'repeat.svg',
      texto:
        'Você escolhe o valor da primeira recarga e as próximas são feitas automaticamente quando seu saldo estiver acabando.',
    },
    {
      id: 2,
      icone: 'card.png',
      texto:
        'Pague com cartão de crédito, nós aceitamos: Alelo Multi, Elo, Visa, Mastercard e American Express.',
    },
    {
      id: 3,
      icone: 'thumbs-up.svg',
      texto:
        'Mais praticidade, pois você não precisa ficar se preocupando em recarregar seu produto.',
    },
  ],
};

export const modalPosPago = {
  titulo: 'Como funciona o pós pago',
  cards: [
    {
      id: 4,
      icone: 'calendario.svg',
      texto:
        'Todo o seu gasto do mês é reunido em uma fatura e você escolhe o melhor dia para o vencimento.',
      debitText:
        'Todo o seu gasto do mês é reunido em uma fatura e você escolhe o melhor dia para o vencimento.',
    },
    {
      id: 5,
      icone: 'vantagens.svg',
      texto:
        'Você paga por cartão de crédito. Tudo lançado em uma única vez. :)',
      debitText:
        'Você pode optar por pagar no cartão de crédito quanto por débito em conta. É só escolher o que é melhor para você. :)',
    },
    {
      id: 6,
      icone: 'card.png',
      texto: 'Confira seu limite pré-aprovado nos canais de auto atendimento',
      debitText: 'O limite mensal para o plano pós é de R$700,00',
    },
  ],
};

export const listTipoPagamento = [
  {
    id: 'recarga-automatica',
    titulo: 'Recarga automática',
    texto:
      'Você escolhe o valor da primeira recarga e as próximas são feitas automaticamente',
    ehRecomendado: { ehRecomendado: true, label: 'O JEITO MAIS PRÁTICO' },
    valor: '18,90',
    checkbox: false,
    modal: 'modalRecarga',
  },
  {
    id: 'pos-pago',
    titulo: 'Pós pago',
    texto: 'Todo o seu gasto do mês é reunido em uma fatura',
    ehRecomendado: { ehRecomendado: false, label: '' },
    valor: '20,90',
    checkbox: false,
    modal: 'modalPosPago',
  },
];

// Início dos cards das modais
export const cardPedagios = {
  id: 'pedagio-auto',
  titulo: 'Passar sem filas em pedágios',
  texto: 'Passagem automática em 100% das estradas pedagiadas',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: 'imgCard01.png',
  tipo: 'direita',
  tipoCentro: {},
};

export const cardPedagiosMoto = {
  id: 'pedagio-moto',
  titulo: 'Perde menos tempo na moto para passar em pedágios*',
  texto:
    'Agora você não precisa mas tirar a carteira do bolso, descer da sua moto ou caçar o dinheiro para o pedagio.',
  subTitulo:
    '* A pulseira e o relógio não funcionam em estacionamentos, somente em pedágios.',
  emBreve: { status: false, texto: '' },
  img: 'imgCard01.png',
  tipo: 'direita',
  tipoCentro: {},
};

export const cardEstacionamento = {
  id: 'estacionamento',
  titulo: 'Passar direto em estacionamentos',
  texto: 'Estacionamentos de rua, de shoppings e aeroportos',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: 'imgCard02.png',
  tipo: 'esquerda',
  tipoCentro: {},
};

export const cardAproximacao = {
  id: 'aproximacao',
  titulo: 'Pagamento por aproximação',
  texto:
    'Basta avisar na cabine do pedágio que você vai pagar com Veloe, encostar o dispositivo no leitor e pronto: passou rapidinho.',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: 'imgCard01.png',
  tipo: 'esquerda',
  tipoCentro: {},
};

export const cardMaisDeUm = {
  id: 'mais-de-um',
  titulo: 'Use em mais de um veículo',
  texto:
    'Recomendados para motociclistas, mas pode ser usado em qualquer veículo',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: 'imgCard01.png',
  tipo: 'direita',
  tipoCentro: {},
};

export const cardExtraPulseira = {
  id: 'extra-pulseira',
  titulo: 'Com a pulseira você: ',
  texto: '',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: '',
  tipo: 'centro',
  tipoCentro: [
    {
      id: 1,
      texto:
        'Passa nos mesmos pedágios que o relógio e tem mais praticidade e conforto',
    },
    { id: 2, texto: 'Simples, leve e discreta' },
    { id: 3, texto: "À prova d'agua" },
  ],
};

export const cardExtraRelogio = {
  id: 'extra-relógio',
  titulo: 'E tem outras funções para a sua rotina: ',
  texto: '',
  subTitulo: '',
  emBreve: { status: false, texto: '' },
  img: '',
  tipo: 'centro',
  tipoCentro: [
    { id: 1, texto: 'Funcionalidades de um relógio, alarme e cronômetro' },
    {
      id: 2,
      texto: 'Monitoramento de batimentos cardíacos e contador de passos',
    },
    {
      id: 3,
      texto:
        'Notificações do seu celular - quando sincronizado com o seu smartphone',
    },
    { id: 4, texto: "À prova d'agua - não se preocupe com as chuvas" },
  ],
};

export const cardCombustivel = {
  id: 'combustivel',
  titulo: 'Pagar o combustível',
  texto:
    'Pode pagar o combustivel do seu carro em vários postos de abastecimento',
  subTitulo: '',
  emBreve: { status: true, texto: 'Em breve' },
  img: 'imgCard03.png',
  tipo: 'direita',
  tipoCentro: {},
};

export const cardZonaAzul = {
  id: 'zona-azul',
  titulo: 'Pagar zona azul',
  texto: 'Pode pagar a Zona Azul, sem precisar ficar contando moedinhas',
  subTitulo: '',
  emBreve: { status: true, texto: 'Em breve' },
  img: 'imgCard04.png',
  tipo: 'esquerda',
  tipoCentro: {},
};

// Modais dos produtos
export const modalAdesivo = {
  imgPrincipal: 'adesivo.png',
  titulo: 'Adesivo',
  imgTituloPrincipal: 'imgTituloPrincipal.png',
  imgVeiculos: [
    { id: 1, img: 'iconeCaminhao.png' },
    { id: 2, img: 'iconeCarro.png' },
  ],
  textoPrincipal: 'Uso em carros e veículos pesados, como caminhões e ônibus',
  cards: [cardPedagios, cardEstacionamento, cardCombustivel, cardZonaAzul],
};

export const modalRelogio = {
  imgPrincipal: 'relogio.png',
  titulo: 'Relogio',
  imgTituloPrincipal: 'imgTituloPrincipal.png',
  imgVeiculos: [{ id: 1, img: 'iconeMoto.png' }],
  textoPrincipal: 'Ideal para motos',
  cards: [cardPedagiosMoto, cardAproximacao, cardMaisDeUm, cardExtraRelogio],
};

export const modalPulseira = {
  imgPrincipal: 'pulseira.png',
  titulo: 'Pulseira',
  imgTituloPrincipal: 'imgTituloPrincipal.png',
  imgVeiculos: [{ id: 1, img: 'iconeMoto.png' }],
  textoPrincipal: 'Ideal para motos',
  cards: [cardPedagiosMoto, cardAproximacao, cardMaisDeUm, cardExtraPulseira],
};

export const tipoAutomoveis = [
  {
    id: 'adesivo',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Adesivo',
    subTitulo: 'Para carros e veículos pesados',
    parcelas: 'A partir de R$ 9,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-adesivo.png',
    valor: 0,
    valorOriginal: 34.9,
    ehGratis: { gratis: true, texto: 'Grátis' },
    modal: 'modalAdesivo',
  },
  {
    id: 'relogio',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Relógio',
    subTitulo:
      'O jeito mais tecnológico, com funções de um relógio inteligente.',
    parcelas: 'A partir de R$ 12,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-relogio.png',
    valor: 100.0,
    valorOriginal: 100.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalRelogio',
  },
  {
    id: 'pulseira',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Pulseira',
    subTitulo: 'O jeito mais simples, prático e discreto de pagar o pedágio',
    parcelas: 'A partir de R$ 7,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-pulseira.png',
    valor: 50.0,
    valorOriginal: 50.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalPulseira',
  },
];
export const tipoMotos = [
  {
    id: 'relogio',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Relógio',
    subTitulo:
      'O jeito mais tecnológico, com funções de um relógio inteligente.',
    parcelas: 'A partir de R$ 12,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-relogio.png',
    valor: 100.0,
    valorOriginal: 100.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalRelogio',
  },
  {
    id: 'pulseira',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Pulseira',
    subTitulo: 'O jeito mais simples, prático e discreto de pagar o pedágio',
    parcelas: 'A partir de R$ 7,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-pulseira.png',
    valor: 50.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalPulseira',
  },
];
export const tipoAutomoveisMotos = [
  {
    id: 'adesivo',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: {
      recomendado: true,
      texto: 'Para carros e veículos pesados',
    },
    titulo: 'Adesivo',
    subTitulo: 'Para carros e veículos pesados',
    parcelas: 'A partir de R$ 9,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-adesivo.png',
    valor: 0,
    valorOriginal: 34.9,
    ehGratis: { gratis: true, texto: 'Grátis' },
    modal: 'modalAdesivo',
  },
  {
    id: 'relogio',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: true, texto: 'Recomendado para motos' },
    titulo: 'Relógio',
    subTitulo:
      'O jeito mais tecnológico, com funções de um relógio inteligente.',
    parcelas: 'A partir de R$ 12,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-relogio.png',
    valor: 100.0,
    valorOriginal: 100.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalRelogio',
  },
  {
    id: 'pulseira',
    checkBox: false,
    quantidade: 1,
    ehRecomendado: { recomendado: false, texto: '' },
    titulo: 'Pulseira',
    subTitulo: 'O jeito mais simples, prático e discreto de pagar o pedágio',
    parcelas: 'A partir de R$ 7,90/mês após período promocional',
    textoDesconto: '6 mensalidades grátis',
    img: 'veloe-pulseira.png',
    valor: 50.0,
    valorOriginal: 50.0,
    ehGratis: { gratis: false, texto: '' },
    modal: 'modalPulseira',
  },
];
export const veiculoList = [
  {
    id: 'automoveis',
    titulo: 'Automóveis',
    texto: 'Carros e veículos pesados, como caminhões e ônibus.',
    img: 'carro.png',
  },
  {
    id: 'motos',
    titulo: 'Motos',
    texto: 'Motos e motonetas.',
    img: 'moto.png',
  },
  {
    id: 'auto-motos',
    titulo: 'Automóveis e motos',
    texto: 'Para todos das categorias automóveis e motos.',
    img: 'carroEmoto.png',
  },
];
export const temNFC = { nfcActive: false };

export const listOndeUsar = [
  {
    id: 'ped-est',
    titulo: 'Pedágios e Estacionamentos',
    texto: 'A partir de R$ 18,90/mês',
    valor: 'R$18,90 após o período promocional',
    textoDesconto: '6 mensalidades grátis',
    temMensalidade: true,
    checkbox: false,
  },
  {
    id: 'ped',
    titulo: 'Pedágios',
    texto: 'R$ 14,90/mês',
    valor: 'R$14,90 após o período promocional',
    textoDesconto: '6 mensalidades grátis',
    temMensalidade: true,
    checkbox: false,
  },
  {
    id: 'est',
    titulo: 'Estacionamentos',
    texto: 'R$ 9,90/mês',
    valor: 'R$9,90 após o período promocional',
    textoDesconto: '6 mensalidades grátis',
    temMensalidade: true,
    checkbox: false,
  },
];

export const getData = (listType) => {
  switch (listType) {
    case 'modalEmailJaExistente':
      return modalEmailJaExistente;
    case 'modalCPFJaExistente':
      return modalCPFJaExistente;
    case 'modalAguarde':
      return modalAguarde;
    case 'modalNaoAprovado':
      return modalNaoAprovado;
    case 'listReceberAdesivo':
      return listReceberAdesivo;
    case 'instituicoes':
      return instituicoes;
    case 'diaPagto':
      return diaPagto;
    case 'listTipoPagamento':
      return listTipoPagamento;
    case 'tipoAutomoveis':
      return tipoAutomoveis;
    case 'tipoMotos':
      return tipoMotos;
    case 'tipoAutomoveisMotos':
      return tipoAutomoveisMotos;
    case 'veiculoList':
      return veiculoList;
    case 'temNFC':
      return temNFC;
    case 'listOndeUsar':
      return listOndeUsar;
    case 'modalPulseira':
      return modalPulseira;
    case 'modalAdesivo':
      return modalAdesivo;
    case 'modalRelogio':
      return modalRelogio;
    case 'modalRecarga':
      return modalRecarga;
    case 'modalPosPago':
      return modalPosPago;
    case 'modalTarifas':
      return modalTarifas;
    case 'modalFinalizandoPagamento':
      return modalFinalizandoPagamento;
    case 'retornoBraspag':
      return retornoBraspag;
    case 'modalTermos':
      return modalTermos;
    default:
      return null;
  }
};
